import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { generateRoutePath } from 'epic-common/src/route';
import SwiperButton from '../../swiperButton/SwiperButton';
import Callout from '../../callout/Callout';
import Swoosh from '../../swoosh/Swoosh';

const NewItemsBlock = ({block, handlePrev, handleNext, active}) => {
    const { headline, description, buttonText, bgImage1, bgImage2 } = block;

    return (
        <div className="home--new-items-block home-section-block">
            <Swoosh skew="right" color="red" active={active} />
            <img src={bgImage1} alt="item-walkaway" className={classNames('item-walkaway', active && 'active')} />
            <img src={bgImage2} alt="item-placer" className={classNames('item-placer', active && 'active')} />
            <SwiperButton onClick={handlePrev} inverted />
            <div className="home-section-block-content">
                <Callout
                    headline={headline}
                    description={description}
                    buttonText={buttonText}
                    buttonLink={generateRoutePath('progression')}
                    align="left"
                    active={active}
                    dark
                />
            </div>
            <SwiperButton onClick={handleNext} />
        </div>
    )
};

NewItemsBlock.propTypes = {
    block: PropTypes.object,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func,
    active: PropTypes.bool
};

NewItemsBlock.defaultProps = {
    block: {},
    handlePrev: fn => fn,
    handleNext: fn => fn,
    active: false
};

export default NewItemsBlock;
